"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = version;
exports.batchedUpdates = batchedUpdates;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const ver = react_1.default.version.split('.').map(parseFloat);
function version() {
    return ver;
}
function batchedUpdates(cb) {
    react_dom_1.default.unstable_batchedUpdates(cb);
}
//# sourceMappingURL=compat.js.map